import './PageNotFound.css'

const PageNotFound = () => {
	return <div className='error'></div>
}

export default PageNotFound
